import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
import { Tooltip, OverlayTrigger, Badge } from "react-bootstrap";
import { sortableHandle } from "react-sortable-hoc";
import {
  toggleActivateDeactivateChallenge,
  fetchManageChallengesList,
  loadEditchallengesData,
  openChallengesModal,
} from "ManagechallengesActions";
const dragUrl = "../../style/images/drag_sign.png";
const DragHandle = sortableHandle(({ sectionname }) => (
  <div
    className="col-md-12 DraggedStuff"
    // style={{ paddingLeft: 4 }}
  >
    <div className="table-td-style ">
      <img src={dragUrl} className="table-grag-image" />
      <span className="" style={{ padding: "0 0 0 16px" }}>
        {sectionname.length > 35
          ? sectionname.substring(0, 35) + "..."
          : sectionname}{" "}
      </span>
    </div>
  </div>
));

const notApplicableNameArr = [
  "completeprofile",
  "globalsearch",
  "communitygetlike",
  "communitygetcomment",
]; // Note : - Profile picture/interest/looking for something for these challenges the pop up will be shown as “Not applicable”

class ChallengeItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  //
  componentDidMount() {}

  // Toggle Active / Deactivate
  activeDeactivateClick = (param1, param2) => {
    var id = param1;
    var isactive = param2 == 1 ? 0 : 1;

    confirmAlert({
      title: LocaleStrings.gamification_chooser_toogle_challenge_title,
      message: LocaleStrings.gamification_chooser_toogle_challenge_message,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            //this.props.session
            this.props.toggleActivateDeactivateChallenge(
              this.props.session,
              id,
              isactive,
              (CallBackResponse) => {
                if (CallBackResponse.success) {
                  this.props.showSuccess(
                    LocaleStrings.gamification_toggle_form_success
                  );

                  if (
                    this.props.managechallengesSelectedTab ==
                    "MANAGECHALLENGES_SINGLE"
                  ) {
                    // Single Challenge
                    this.props.fetchManageChallengesList(
                      this.props.session,
                      this.props.searchKey,
                      "single",
                      (CallBackResponse) => {}
                    );
                  } else {
                    // For Recurring Chaleenges call
                    this.props.fetchManageChallengesList(
                      this.props.session,
                      this.props.searchKey,
                      "recurring",
                      (CallBackResponse) => {}
                    );
                  }
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  // Modal Call function
  editChallengeCallback(obj) {
    var challenges = this.props.challenge;
    this.props.loadEditchallengesData(
      challenges,
      this.props.staticTemplteHtml.data
    );
    this.props.openChallengesModal({
      showModal: true,
      idFieldName: challenges.id,
      idFieldLable: challenges.id,
    });
  }

  render() {
    let { challenge } = this.props;
    let checked = false;
    if (challenge.isactive == 1) {
      checked = true;
    }

    return (
      <div
        className="row"
        style={{
          fontWeight: "normal",
          color: "rgb(63,68,88)",
          borderTop: "1px solid #e6edf3",
          padding: "10px 16px",
          cursor: "move",
        }}
      >
        <div className="col-md-4 col-sm-3">
          <DragHandle sectionname={this.props.challenge.challengename} />
        </div>
        <div className="col-md-3 col-sm-2">
          <span className="table-td-style">
            {this.props.challenge.challengedesc}{" "}
          </span>
        </div>
        <div className="col-md-1 col-sm-2">
          <span className="table-td-style ">
            {_.indexOf(
              notApplicableNameArr,
              this.props.challenge.challengetype
            ) > -1 ? (
              LocaleStrings.gamification_not_applicable
            ) : (
              <Badge
                bg="primary"
                className={
                  this.props.challenge.showpopup == 1
                    ? "gamifi-bg-success"
                    : "gamifi-bg-danger"
                }
              >
                {this.props.challenge.showpopup == 1 ? "Yes" : "No"}
              </Badge>
            )}
          </span>
        </div>
        <div className="col-md-1 col-sm-1">
          <span className="table-td-style">
            {this.props.challenge.rewardtype === "award"
              ? LocaleStrings.na
              : this.props.challenge.points + " pts"}
          </span>
        </div>
        <div className="col-md-3 col-sm-4 d-flex justify-space-around">
          <button
            className="button-default-tr"
            onClick={this.editChallengeCallback.bind(this)}
          >
            {LocaleStrings.edit}
          </button>{" "}
          <OverlayTrigger
            key="manage"
            placement="top"
            overlay={
              <Tooltip id="tooltip-manage">
                {LocaleStrings.gamification_active_inactive_text}
              </Tooltip>
            }
          >
            {({ ref, ...triggerHandler }) => (
              <label
                className="toolitp-btn poll-switch pull-right"
                style={{ margin: 0 }}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() =>
                    this.activeDeactivateClick(
                      this.props.challenge.id,
                      this.props.challenge.isactive
                    )
                  }
                />
                <span className="poll-slider poll-round"></span>
                <span className="tooltiptext-top-left">
                  {LocaleStrings.gamification_active_inactive_text}
                </span>
              </label>
            )}
          </OverlayTrigger>
          {/* <span className="table-td-style">
          </span> */}
        </div>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  var { session, managechallengesSelectedTab } = state;

  return {
    session: state.session,
    managechallengesSelectedTab,
    staticTemplteHtml: state.staticTemplteHtml,
  };
};
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  toggleActivateDeactivateChallenge,
  fetchManageChallengesList,
  loadEditchallengesData,
  openChallengesModal,
})(ChallengeItem);
